import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ToastMessage } from '../types/message.types';

@Injectable({
  providedIn: 'root',
})
export class SingleToastMessageService {
  constructor(private toastr: ToastrService) {}

  add(message: ToastMessage): void {
    this.clear();
    this.showToast(message);
  }

  addAll(messages: ToastMessage[]): void {
    this.clear();
    if (!messages?.length) {
      return;
    }

    this.showToast(messages[messages.length - 1]);
  }

  clear(_key?: string): void {
    this.toastr.clear();
  }

  private showToast(message: ToastMessage): void {
    const detail = message.detail?.trim() ?? '';
    const summary = message.summary?.trim() ?? '';
    const body = detail || summary;

    if (!body) {
      return;
    }

    const title = detail && summary ? summary : '';
    const options = {
      timeOut: message.sticky ? 0 : (message.life ?? 5000),
      extendedTimeOut: message.sticky ? 0 : 1000,
      closeButton: false,
      progressBar: false,
      positionClass: 'toast-bottom-center',
      tapToDismiss: true,
    };

    switch (message.severity) {
      case 'success':
        this.toastr.success(body, title, options);
        break;
      case 'error':
        this.toastr.error(body, title, options);
        break;
      case 'warn':
      case 'warning':
        this.toastr.warning(body, title, options);
        break;
      case 'info':
        this.toastr.info(body, title, options);
        break;
      default:
        this.toastr.show(body, title, options);
        break;
    }
  }
}

/** Drop-in replacement for the removed PrimeNG MessageService token. */
export { SingleToastMessageService as MessageService };
